export const FETCH_CONSENTS = 'FETCH_CONSENTS';
export const FETCH_CONSENTS_REQUEST = 'FETCH_CONSENTS_REQUEST';
export const FETCH_CONSENTS_SUCCESS = 'FETCH_CONSENTS_SUCCESS';
export const FETCH_CONSENTS_ERROR = 'FETCH_CONSENTS_ERROR';

export const UPDATE_CONSENTS = 'UPDATE_CONSENTS';
export const UPDATE_CONSENTS_REQUEST = 'UPDATE_CONSENTS_REQUEST';
export const UPDATE_CONSENTS_SUCCESS = 'UPDATE_CONSENTS_SUCCESS';
export const UPDATE_CONSENTS_ERROR = 'UPDATE_CONSENTS_ERROR';

export const UPDATE_MESSAGING_CONSENTS = 'UPDATE_MESSAGING_CONSENTS';
export const UPDATE_MESSAGING_CONSENTS_SUCCESS = 'UPDATE_MESSAGING_CONSENTS_SUCCESS';

export const UPDATE_BIOMETRIC_CONSENTS = 'UPDATE_BIOMETRIC_CONSENTS';
export const UPDATE_BIOMETRIC_CONSENTS_SUCCESS = 'UPDATE_BIOMETRIC_CONSENTS_SUCCESS';
export const UPDATE_BIOMETRIC_CONSENTS_ERROR = 'UPDATE_BIOMETRIC_CONSENTS_ERROR';

export const PRIVACY_SETTINGS_PROMPT = 'PRIVACY_SETTINGS_PROMPT';
export const PRIVACY_SETTINGS_MANAGE = 'PRIVACY_SETTINGS_MANAGE';

// CMP keys for partner integration
export const KEY_CATEGORY_ANALYTICS = ':analytics';
export const KEY_CATEGORY_MARKETING = ':marketing';

export const KEY_APPSFLYER = 'apps_flyer';
export const KEY_GOOGLE_ANALYTICS = 'google_analytics';
export const KEY_GOOGLE_FLOODLIGHT = 'google_floodlight';
export const KEY_GOOGLE_SIGNALS = 'google_signals';
// this is tentative until we get final confirmation what the consent object looks like
export const KEY_FACEBOOK_PIXEL = 'facebook_pixel';
export const KEY_GOOGLE_PIXEL = 'google';
export const KEY_PINTEREST_PIXEL = 'pinterest';
export const KEY_TIKTOK_PIXEL = 'tik_tok';
export const KEY_SNAPCHAT_PIXEL = 'snap';
